'use client';

import { Contact } from '@/components/contact';
import { WebGLHero } from '@/components/webgl-hero';
import { FeaturesBlock, HeroBlock, ProcessBlock, WhyChooseUsBlock, } from '@/features/home/blocks';
import { CaseStudiesBlock } from '@/features/home/blocks/case-studies/case-studies-block';
import { MainLayout } from '@/layouts/main';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';
import type { FC } from 'react';

type HomePageClientProps = {
  locale: string;
};

export const HomePage: FC<HomePageClientProps> = ({ locale }) => {
  return (
    <>
      <Head>{generateNextSeo({
        title: `Home - ${locale}`,
        description: `Welcome to our site - ${locale}`
      })}</Head>
      <MainLayout>
        <WebGLHero />
        <div className="relative">
          <HeroBlock />
          <FeaturesBlock />
          <CaseStudiesBlock />
          <ProcessBlock />
          <WhyChooseUsBlock />
          <Contact />
        </div>
      </MainLayout>
    </>
  );
};
